import { Head } from 'shared/page/Head';
import { Main } from 'shared/page/Main';

import styles from './info.module.css';

const InfoPage = () => (
    <>
        <Head
            title="Slik sorteres søkeresultatene | FINN reise"
            description="Informasjon on hvordan søkeresultatene på FINN reise sorteres"
            canonical={'https://www.finn.no/reise/info/'}
        />
        <Main className={styles.main} customContainer>
            <div className={styles.content}>
                <div>
                    <h1>FINN Reise</h1>
                    <p>
                        FINN reise er en reisesøkemotor som henter inn og sammenligner priser fra forskjellige leverandører, flyselskap og
                        reisebyråer. Vi lager enkle oversikter basert på informasjonen vi mottar.
                    </p>
                    <p>
                        Når du søker etter reiser på FINN reise, så kan du enkelt sammenligne alle alternativene for samme flyvning, hotell
                        eller pakkereise, og bestemme selv hvor du vil bestille - enten det er direkte fra flyselskapet, hotellet eller fra
                        en annen reisenettside.
                    </p>
                    <p>Slik fungerer FINN reise:</p>
                </div>
                <section>
                    <h2 id="fly">Fly</h2>
                    <p>
                        Samme tilbud fra forskjellige flyselskap og leverandører er gruppert i samme tilbud, og sortert etter pris. Direkte
                        flyselskap får sin egen liste innenfor gruppen.
                    </p>
                    <h3>Sortering etter &quot;Best&quot;</h3>
                    <p>
                        Best er sortert etter en kombinasjon av både pris og varighet. Varighet vektes litt mer enn pris, så tilbud med
                        dårligere varighet (for eksempel flere og/eller lengre mellomlandinger) kommer ofte lenger ned på listen.
                    </p>
                    <h3>Sortering etter &quot;Billigst&quot;</h3>
                    <p>
                        Vår Billigst-sortering er kun sortert etter pris, basert på billigste tilbud i hver tur, og gir deg raskt og enkelt
                        oversikt over billigste tilbud.
                    </p>
                    <h3>Sortering etter &quot;Raskest&quot;</h3>
                    <p>Vår Raskest-sortering er sortert etter varighet, og gir deg raskt og enkelt oversikt over raskeste tilbud.</p>
                </section>
                <section>
                    <h2 id="hotell">Hotell</h2>
                    <p>
                        Som standard rangeres resultatene etter vår &quot;popularitets&quot;-algoritme, som er basert på noen
                        nøkkelparametere: pris, gjestevurderinger og popularitet (målt i klikk). Den relative betydningen av parameterne er
                        spesifikk for hvert sett med søkeresultater. F.eks. vil pris være mindre relevant dersom prisforskjellen er svært
                        liten. Vi tar også med det gjennomsnittlige inntektspotensialet for FINN reise fra hvert hotellresultat. I tillegg
                        kan du sortere resultatene etter
                        <strong> pris, hotellstandard, gjestevurderinger</strong> og <strong>hotellnavn</strong>.
                    </p>
                    <p>
                        Når flere rom er tilgjengelig eller flere leverandører tilbyr avtaler på samme hotell/eiendom sorteres alltid de
                        ulike rommene og leverandørene etter pris, og laveste pris vises først.
                    </p>
                </section>
                <section>
                    <h2 id="pakkereiser">Fly+hotell / Pakkereiser</h2>
                    <p>
                        I vårt pakkereisesøk sammenstiller vi alle tilbudene fra ulike aktører som tilbyr pakkereiser til ditt ønskede
                        reisemål.
                    </p>
                    <p>
                        Resultatene sorteres etter vår &quot;&quot;beste treff&quot;-algoritme som er basert på avstand fra viktige punkter
                        som bysentrum og strand (som angitt av våre leverandører), pris, hotellets stjernerangering, lengde på oppholdet og
                        hvorvidt det er en charter-reise eller ikke. Når flere rom er tilgjengelig eller flere leverandører tilbyr avtaler
                        på samme hotell/eiendom sorteres alltid de ulike rommene og leverandørene etter pris, og laveste pris vises først.
                    </p>
                    <p>
                        Du kan også sortere etter <strong>&quot;Prisnivå&quot;</strong> som gir deg oversikt kun sortert etter pris. Mens
                        sorteringen <strong>&quot;Hotellstandard&quot;</strong> gir deg oversikt over hotellstandard etter synkende
                        rangering (stjerner).
                    </p>
                </section>
                <section>
                    <h2 id="restplasser">Restplasser</h2>
                    <p>
                        Resultatene i vårt Restplasser-søk er sortert på <strong>&quot;Pris per person&quot;</strong> og gir deg oversikt
                        over laveste pris per person og oppover. Mens sorteringen <strong>&quot;Avreisedato&quot;</strong> er sortert på
                        avreisedato og fremover i tid.
                    </p>
                </section>
                <section>
                    <h2 id="feriehus">Feriehjem</h2>
                    <h3>Sortering etter &quot;Beste treff&quot;</h3>
                    <p>
                        Rekkefølgen bestemmes av hvor godt annonsen samsvarer med søket ditt. Vi ser på en rekke parametere som tittelen og
                        beskrivelsen i annonsen, antall bilder, fasiliteter, beliggenhet og utleiers engasjement.
                    </p>
                    <h3>Sortering etter publiseringsdato</h3>
                    <p>
                        Sorteringen er basert på datoen annonsen ble publisert eller fornyet. Nyeste annonser kommer øverst i
                        resultatlisten.
                    </p>
                    <h3>Sortering etter numeriske felter</h3>
                    <p>
                        Rekkefølgen er sortert etter numeriske felter som: pris, og antall soverom. Du kan filtrere i begge retninger, slik
                        at du f.eks. kan velge om du vil sortere etter dyreste eller billigste først.
                    </p>
                    <h3>Betalt plassering</h3>
                    <p>
                        Det er to typer betalt innhold i resultatlisten: den ene er at FINN-brukere kan betale for en bedre plassering av
                        deres annnoser i resultatlisten, og disse blir merket med &quot;Betalt plassering&quot;. Den andre er at bedrifter
                        kan betale for reklameposisjoner, disse er merket &quot;Annonse&quot;.
                    </p>
                </section>
            </div>
        </Main>
    </>
);

export default InfoPage;
